import { useLocation, useNavigate } from 'react-router-dom';
import { sanitizePathname } from 'packages/helpers/navigation';

// TODO: This hook calls navigate in every fn for changing queryParams – that cause firing
// navigate after navigate that is a really bad practice and can cause multiple bugs.
// Seems like a big refactoring that require a lot of time
const useQueryParams = () => {
    // react-router's location, not window.location: `pathname` is fed back into
    // navigate() below, so it has to be the in-app route rather than the real
    // server path the app happens to be mounted on.
    const location = useLocation();
    const navigate = useNavigate();

    const setQueryParam = (paramKey: string, paramValue: null | string | string[]) => {
        const query = new URLSearchParams(location.search);

        if (Array.isArray(paramValue)) {
            query.delete(paramKey);
            paramValue.forEach((value) => query.append(paramKey, value));
        } else if (paramValue) {
            query.set(paramKey, paramValue);
        } else {
            query.delete(paramKey);
        }

        navigate({ pathname: sanitizePathname(location.pathname), search: query.toString() }, { replace: true });
    };

    const getQueryParam = (paramKey: string) => {
        return new URLSearchParams(location.search).get(paramKey);
    };

    const getQueryParamArray = (paramKey: string) => {
        return new URLSearchParams(location.search).getAll(paramKey);
    };

    const resetQueryParams = (paramKeys: string[]) => {
        const query = new URLSearchParams(location.search);

        paramKeys.forEach((key) => {
            query.delete(key);
        });

        navigate({ pathname: sanitizePathname(location.pathname), search: query.toString() }, { replace: true });
    };

    const resetAllQueryParams = () => {
        navigate({ pathname: sanitizePathname(location.pathname), search: '' }, { replace: true });
    };

    const getAllQueryParams = () => new URLSearchParams(location.search).toString();
    const getAllQueryParamsRaw = () => new URLSearchParams(location.search);

    const restoreQueryParams = (queryString: string) => {
        navigate({ pathname: sanitizePathname(location.pathname), search: queryString || '' }, { replace: true });
    };

    return {
        setQueryParam,
        getQueryParam,
        getQueryParamArray,
        resetQueryParams,
        resetAllQueryParams,
        getAllQueryParams,
        getAllQueryParamsRaw,
        restoreQueryParams,
    };
};

export default useQueryParams;
